@if (showLdr) {
<ds-loading></ds-loading>
}
<div class="page-header">
  <div class="align-items-md-center">
    <div class="row hdrBar">
      <div class="col-lg-12 col-md-12 mg-a">
        @if (clntDtls && clntDtls.length > 0) {
        <h1>
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
      </div>
    </div>
  </div>
</div>
<div class="page-body">
  <div class="fltr">
    <form nz-form [formGroup]="validateForm" class="form">
      <div class="row" style="padding: 10px">
        <div class="col-md-3">
          <nz-form-item style="display: block">
            <div class="fltrlabel">Select District</div>
            <div>
              <nz-form-control>
                <nz-select
                  nzPlaceHolder="Select Type"
                  formControlName="dstrt_id"
                  (ngModelChange)="getdistrictid($event)"
                >
                  <nz-option nzValue="0" nzLabel="All"> </nz-option>
                  @for (v of districts; track v) {
                  <nz-option [nzValue]="v.tnt_id" [nzLabel]="v.tnt_nm">
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>
        <div class="col-md-3">
          <nz-form-item style="display: block">
            <div class="fltrlabel">Select Mandal</div>
            <div>
              <nz-form-control>
                <nz-select
                  nzPlaceHolder="Select Type"
                  formControlName="mndl_id"
                  (ngModelChange)="getsbstn($event)"
                >
                  <nz-option [nzValue]="0" nzLabel="All"> </nz-option>
                  @for (d of mandals; track d) {
                  <nz-option [nzValue]="d.mndl_id" [nzLabel]="d.mndl_nm">
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>
        <div class="col-md-3">
          <nz-form-item style="display: block">
            <div class="fltrlabel">Select Substation</div>
            <div>
              <nz-form-control>
                <nz-select
                  nzPlaceHolder="Select Type"
                  formControlName="oms_pop_id"
                >
                  <nz-option [nzValue]="0" nzLabel="All"> </nz-option>
                  @for (d of sbstns; track d) {
                  <nz-option [nzValue]="d.oms_pop_id" [nzLabel]="d.pop_nm">
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>
        <div class="col-md-3">
          <div class="row rptBtnRw">
            <button type="primary" class="btn-sm" (click)="getDtls()">
              Get Data
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="fltrbg">
    <!-- <div class="" ><span>Substation Details</span></div> -->

    <div>
      <!-- <div> -->

      @if (sbstndtls) {
      <div>
        <div
          class="crd_style"
          style="
            background-color: #fffaf0; /* White background */

            padding: 15px;
            border-radius: 5px;
            height: 47%;
          "
        >
          <h5 style="color: #e54848; font-size: 18px">
            Substation Location and APSFL Details
          </h5>
          <div class="row m-0">
            <div class="col-4 hdr">Address</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.adrs_tx || "NA" }}</span>
            <!-- /{{sbstndtls.pin_cd || 'NA'}}-->
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">Gram Panchayat</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue">{{ sbstndtls.gp_nm || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">Substation Type</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.pop_typ || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">Substation Code</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue">{{ sbstndtls.pop_cd || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">Location Type</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.pin_cd || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">Substation I & C Year</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.lat || "NA" }}</span>
          </div>
          <!-- <div class="row m-0">
            <div class="col-4 hdr">PIN Code</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{sbstndtls.pin_cd || 'NA'}}</span>
          </div> -->
          <!-- <div class="row m-0">
          <div class="col-4 hdr">Latitude</div>
          <span class="col-1">:</span>
          <span class="col-auto vlue"> {{sbstndtls.lat || 'NA'}}</span>
        </div>
        <div class="row m-0">
          <div class="col-4 hdr">Longitude</div>
          <span class="col-1">:</span>
          <span class="col-auto vlue"> {{sbstndtls.lng || 'NA'}}</span>
        </div> -->
        </div>
        <div
          class="col-md-12 crd_style"
          style="
            background-color: #f0faff; /* White background */

            padding: 15px;
            border-radius: 5px;
            height: 51%;
          "
        >
          <h5 style="color: #e54848; font-size: 18px">Substation Details</h5>
          <div class="row m-0">
            <div class="col-4 hdr">Connectivity Type</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.pop_typ || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">Equipment Installed in</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue">{{ sbstndtls.pin_cd || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">Subscribe Type</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.pin_cd || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">Subscribers</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.lat || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">EB Connected Load in KW</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.lat || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">EB Service Number</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.lat || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">Present Site Load in Amps</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.lat || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">No of Earth Pits</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.lat || "NA" }}</span>
          </div>
          <div class="row m-0">
            <div class="col-4 hdr">BBNL Router Availability</div>
            <span class="col-1">:</span>
            <span class="col-auto vlue"> {{ sbstndtls.lat || "NA" }}</span>
          </div>
        </div>
        <!-- <div class="crd_style" style="      background-color: #f0fff3; /* White background */
                
                padding: 15px;
                border-radius: 5px;    height:47%;">
                    <h5 style="    color: #e54848;
    font-size: 18px;
                   "> Substation APSFL INFO</h5>
      <div class="row m-0">
        <div class="col-4 hdr">Substation Type</div>
        <span class="col-1">:</span>
        <span class="col-auto vlue"> {{sbstndtls.pop_typ || 'NA'}}</span>
      </div>
      <div class="row m-0">
        <div class="col-4 hdr">Substation Code</div>
        <span class="col-1">:</span>
        <span class="col-auto vlue">{{sbstndtls.pop_cd || 'NA' }}</span>
      </div>
      <div class="row m-0">
        <div class="col-4 hdr">Location Type</div>
        <span class="col-1">:</span>
        <span class="col-auto vlue"> {{sbstndtls.pin_cd || 'NA'}}</span>
      </div>
      <div class="row m-0">
        <div class="col-4 hdr">Substation I & C Year</div>
        <span class="col-1">:</span>
        <span class="col-auto vlue"> {{sbstndtls.lat || 'NA'}}</span>
      </div>
      <div>
      </div>
    </div> -->
      </div>
      }

      <div>
        <div
          id="livemap"
          style="
            margin-top: 2%;
            position: relative;
            height: 101%;
            border: 8px solid white;
            border-radius: 10px;
          "
        ></div>
      </div>
    </div>
  </div>

  <div
    class="col-md-12 mt-20"
    style="padding: 0px; padding: 0px; margin-top: 30px"
  >
    <div class="row">
      <div class="col-md-4">
        <div
          class="crd_style"
          (click)="selctedcard('WORKS', '#544795')"
          style="margin-top: 5px; background-image: none"
        >
          <div class="row" style="align-items: baseline">
            <div class="col-md-5 cstmcol">
              <div class="actvts">
                Activities
                <span style="color: #ffdaa1"
                  >({{ WorksCrdData?.ttl_wrks }})</span
                >
              </div>
            </div>
            <div class="col-md-7" style="text-align: right">
              <!-- <div class="col-md-6" style="text-align: center;"> -->
              @for (t of tabsActdata; track t) {
              <div
                class="tabs-data"
                (click)="slectdActTab(t)"
                [ngClass]="t.tab_id == slctdActdt ? 'slct_dt' : 'dflt_dt'"
              >
                {{ t.tab_nm }}
              </div>
              }
              <!-- </div> -->
            </div>
          </div>
          <div class="row rwpdng">
            <div class="col-md-3">
              <div class="cnt">{{ WorksCrdData?.in_prgrs }}</div>
              <div class="crd_title">
                <span class="cstmfnt" style="color: #f19000"> In Progress</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="cnt">{{ WorksCrdData?.cmpltd_wrks }}</div>
              <div class="crd_title">
                <span class="cstmfnt" style="color: #4caf50"> Completed</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="cnt">
                {{ INRFormater(WorksCrdData?.cstmr_efctd_ct || 0) }}
              </div>
              <div class="crd_title">
                <span class="cstmfnt" style="color: #3f51b5">
                  CAF's Effected(In Progress)
                </span>
              </div>
            </div>
          </div>

          <app-chart [options]="chartOptions"></app-chart>
          @if (slectdCrd == 'WORKS') {
          <span
            nz-icon
            nzType="caret-down"
            nzTheme="outline"
            style="
              position: absolute;
              left: 50%;
              font-size: 30px;
              color: #544795;
            "
          ></span>
          }
        </div>
      </div>
      <div class="col-md-8">
        <div
          class="crd_style"
          (click)="selctedcard('ASSETS', '#3e8fb3')"
          style="
            height: 90%;
            margin-bottom: 0px;
            margin-top: 5px;
            background-image: none;
          "
        >
          <div class="row">
            <div class="col-md-12 cstmcol">
              <div class="actvts" style="background: #3e8fb3">
                Assets
                <span style="color: #ffdaa1"
                  >({{ astcnts && astcnts.length ? astcnts.length : 0 }})</span
                >
              </div>
            </div>
            <div class="row rwpdng w-100" style="padding-top: 20px">
              @for (a of tpAstType; track a) {
              <div class="col-2">
                <div (click)="getAstTypWs($event)">
                  <div class="row">
                    <!-- <div class="col-md-3">
              <span> <i nz-icon nzType="eye" nzTheme="outline" style="font-size: 30px;"></i></span>
            </div> -->
                    <div class="col-md-12">
                      <!-- <span> <i nz-icon [nzType]="a?.icn_tx" nzTheme="outline" style="font-size: 40px;    color: #eb9e9e"></i></span> -->
                      <img
                        [src]="$safeNavigationMigration(a?.icn_tx)"
                        height="50"
                        width="50"
                      />
                      <!-- <img src="assets/images/apsfl/ACs.jpg" height="100" width="100"> -->
                      <!-- <img src="assets/images/apsfl/truck.gif" alt=""> -->
                      <div class="cnt">{{ a?.count }}</div>
                      <div class="crd_title">
                        <span class="cstmfnt" style="color: #3f51b5">{{
                          a?.ast_typ_nm
                        }}</span>
                        <!-- <span> <i nz-icon nzType="eye" nzTheme="outline"></i></span>  -->
                      </div>
                    </div>
                    <!-- <div class="col-md-1">
          </div> -->
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        @if (slectdCrd == 'ASSETS') {
        <span
          nz-icon
          nzType="caret-down"
          nzTheme="outline"
          style="position: absolute; left: 50%; font-size: 30px; color: #3e8fb3"
        ></span>
        }
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div
        class="cstmTb px-4 pt-2 crd_style"
        style="margin-top: 0px; margin-top: 5px; background-image: none"
      >
        <div class="card_ttl">
          <div class="row">
            <div class="col-md-8">
              @if (slectdCrd == 'WORKS') {
              <div class="card_hdr_ttl slctd-crd" style="position: relative">
                Activities
              </div>
              } @if (slectdCrd == 'ASSETS') {
              <div class="card_hdr_ttl slctd-crd" style="position: relative">
                Assets
              </div>
              }
            </div>
            @if (slectdCrd == 'WORKS') {
            <div class="col-md-10">
              <div class="row pstnCls">
                <div
                  class="col-md-12"
                  style="text-align: left; padding-left: 20px"
                >
                  @if (lvl_id!=3) {
                  <nz-range-picker
                    [(ngModel)]="dateRange"
                    [nzFormat]="'dd-MM-yyyy'"
                    (ngModelChange)="onChangeDate()"
                  ></nz-range-picker>
                  }
                </div>
              </div>
            </div>
            }
            <div class="col-md-2"></div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 mgnb-2 p-8">
          <app-data-grid
            [totalItems]="gridTotals0"
            [groupItems]="gridGroups0"
            id="gridContainer"
            class="p-8"
            style="width: 100%"
            [dataSource]="gridData"
            [legacyColumns]="columnDefs"
            [searchPanel]="true"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="true"
            exportFileName="Substation"
            [pageSize]="10"
            [allowedPageSizes]="[5, 10, 25, 50]"
            [showPageSizeSelector]="true"
            [showBorders]="true"
            (cellClick)="onCellClick($event)"
            [cellPrepared]="bound_onCellPrepared"
          >
            <!--    -->

            <app-grid-column
              [visible]="tb_id == 1"
              [showInColumnChooser]="false"
              type="buttons"
              [width]="100"
              caption="View"
              cellTemplate="editTemplate"
            ></app-grid-column>
            <ng-template appGridCell="editTemplate" let-data="cell"
              ><div>
                @if (data.rowType=='data') {
                <div>
                  @if (tb_id==1) {
                  <div class="tblEdtBtn" (click)="gotoProfile(data, 'work')">
                    <i nz-icon nzType="eye" nzTheme="outline"></i>
                    <p>View Profile</p>
                  </div>
                  }
                </div>
                }
              </div></ng-template
            >
          </app-data-grid>
        </div>
      </div>
    </div>
  </div>
</div>

<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="dwrWdth"
  [nzVisible]="sidenav"
  [nzTitle]="drwerTitle"
  (nzOnClose)="closeSideBar()"
  nzWrapClassName="wrkPrfleDrawer"
>
  <ng-container *nzDrawerContent>
    @if (appCond==1) {
    <div>
      <app-wrok-profile [wrkData]="wrkData"></app-wrok-profile>
    </div>
    } @if (appCond==2) {
    <div class="apsfl_dshbrd">
      <app-emplye-prfle [wrkData]="wrkData"></app-emplye-prfle>
    </div>
    } @if (appCond==3) {
    <div class="apsfl_dshbrd">
      <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
    </div>
    } @if (appCond==4) {
    <div class="apsfl_dshbrd">
      <app-trip-timeline [tripId]="slctd_trp"></app-trip-timeline>
    </div>
    }
  </ng-container>
</nz-drawer>
